import { Box, styled } from '@mui/material'

export const StyledWidgetPieChartStatistic = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: '16px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(2),
  position: 'relative',
  height: '100%',
  flex: 2,
  minWidth: 0,
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2, 1.5),
  },
}))

export const CustomLegend = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: theme.spacing(2),
  width: '100%',
  '& > div': {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(0.1),
    '& > span': {
      width: '10px',
      height: '10px',
      flexShrink: 0,
      display: 'inline-block',
    },
    '& > p': {
      color: theme.palette.text.primary,
      fontSize: '11px',
    },
    '& > p:nth-of-type(1)': {
      flex: 1,
      minWidth: 0,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& > p:nth-of-type(2)': {
      flexShrink: 0,
      fontSize: '10px',
      color: '#888888',
    },
  },
}))

export const CustomTooltip = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '8px',
  padding: theme.spacing(2),
  width: '250px',
  height: '100px',
  position: 'relative',
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  backdropFilter: 'blur(8px)',
  WebkitBackdropFilter: 'blur(8px)',
  boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
}))
